import { useCallback, useMemo } from "react";
import { useCompaniesStore } from "../../../store/admin/companiesStore";
import { useDevicesStore } from "../../../store/admin/devicesStore";
import { useIntegratorsStore } from "../../../store/reseller-admin/integratorsStore";

export interface SelectOption {
  value: string;
  label: string;
}

export const useIntegradoresOptions = () => {
  const allCompanies = useCompaniesStore((state) => state.allCompanies);
  const companies = useCompaniesStore((state) => state.companies);
  const fetchAllCompanies = useCompaniesStore(
    (state) => state.fetchAllCompanies
  );

  const devices = useDevicesStore((state) => state.devices);
  const devicesLoading = useDevicesStore((state) => state.loading);
  const fetchDevices = useDevicesStore((state) => state.fetchDevices);

  const integrators = useIntegratorsStore((state) => state.integrators);
  const fetchIntegrators = useIntegratorsStore(
    (state) => state.fetchIntegrators
  );

  const loadCompanies = useCallback(() => {
    fetchAllCompanies();
  }, [fetchAllCompanies]);

  const loadDevices = useCallback(() => {
    fetchDevices({ limit: 500, page: 1 });
  }, [fetchDevices]);

  const loadIntegrators = useCallback(() => {
    fetchIntegrators({ limit: 100, page: 1 });
  }, [fetchIntegrators]);

  const companyOptions = useMemo<SelectOption[]>(() => {
    const source = allCompanies.length > 0 ? allCompanies : companies;
    return source.map((c) => ({ value: c.id, label: c.name }));
  }, [allCompanies, companies]);

  const deviceOptions = useMemo<SelectOption[]>(() => {
    return devices.map((d) => ({
      value: d.id,
      label: d.vehicleName || d.name || d.identifier || d.id,
    }));
  }, [devices]);

  const integratorOptions = useMemo<SelectOption[]>(() => {
    const seen = new Set<string>();
    const opts: SelectOption[] = [];
    for (const it of integrators) {
      const adapter = it.adapter;
      if (!adapter || seen.has(adapter)) continue;
      seen.add(adapter);
      opts.push({ value: adapter, label: it.name ? `${it.name}` : adapter });
    }
    return opts;
  }, [integrators]);

  return {
    companyOptions,
    deviceOptions,
    integratorOptions,
    devicesLoading,
    loadCompanies,
    loadDevices,
    loadIntegrators,
  };
};
